import AddInvitationModal from './AddInvitationModal';
import './AddInvitationModal.scss';

export default AddInvitationModal;
